import React from 'react';

const Header: React.FC = () => {
    return (
        <header className="app-header">
            <div className="logo">LucidMe</div>
        </header>
    );
};

export default Header; 